import { render, staticRenderFns } from "./mrpay.vue?vue&type=template&id=390ee964&scoped=true&"
import script from "./mrpay.vue?vue&type=script&lang=js&"
export * from "./mrpay.vue?vue&type=script&lang=js&"
import style0 from "./mrpay.vue?vue&type=style&index=0&id=390ee964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390ee964",
  null
  
)

export default component.exports